import { fetchApi } from '@/config/axiosSetting';
import { GetPropertyInsurancePropType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPropertyInsurance/getPropertyInsurance.type';
import { PropertyInsuranceResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/types/PropertyInsurance.type';

export const getPropertyInsuranceFunction = (
  params: GetPropertyInsurancePropType,
): Promise<
PropertyInsuranceResponseType
> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/insurance_information/`,
    {
      params: {
        damaged_id: params.damaged_id,
      },
    },
  );
};
